module.exports = __webpack_public_path__ + "static/media/star_outline.838def41.svg";